// extracted by mini-css-extract-plugin
export default {"image-preview":"ImagePreview_image-preview__NhgAz","svg":"ImagePreview_svg__MW0Id","image":"ImagePreview_image__NbxBN","backdrop":"ImagePreview_backdrop__F6npE"};